import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
});

const token = localStorage.getItem("accessToken");

if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

apiClient.interceptors.request.use(
  (config) => {
    config.params = {
      // api_token: localStorage.getItem("accessToken"),
      ...config.params,
    };
    
    // Add organization ID header if available
    const selectedOrganizationId = localStorage.getItem('selectedOrganizationId') || localStorage.getItem('organization-id');
    if (selectedOrganizationId) {
      config.headers = {
        ...config.headers,
        'organization-id': selectedOrganizationId,
      };
    }
    
    return {
      ...config,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        ...config.headers,
      },
    };
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      // Best-effort server-side logout to revoke the token
      const token = localStorage.getItem("accessToken");
      if (token) {
        try {
          await axios.post(
            `${process.env.REACT_APP_API_PATH}auth/logout`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              withCredentials: true,
            }
          );
        } catch {
          // Ignore — best effort
        }
      }

      localStorage.removeItem("accessToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("tokenExpiry");
      localStorage.removeItem("loginTimestamp");

      window.location.href = "/";
    }
    return Promise.reject(error.response.data);
  }
);

const { get, post, put, delete: destroy, patch } = apiClient;
export { get, post, put, destroy, patch };